<template>
  <v-container>
    <v-row>
      <v-col>
        <DeviceLiveView v-if="device.mode === 'LiveView'" :userStarted='userStarted'/>
        <template v-else>
          Captured on {{imageTimestamp}}
          <DeviceImage360 v-if="isVrCamera" :image="thumb"></DeviceImage360>
          <DeviceImage v-else :image="thumb"></DeviceImage>
        </template>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn @click="toggleLive">Live Preview</v-btn>
      </v-col>
      <v-col hidden>
        <v-btn @click="snackbar = true">Record</v-btn>
        <v-snackbar v-model="snackbar">
          Not yet implemented.
          <v-btn @click="snackbar = false">Close</v-btn>
        </v-snackbar>
      </v-col>
      <v-col hidden>
        <v-btn @click="snackbar = true">Snapshot</v-btn>
        <v-snackbar v-model="snackbar">
          Not yet implemented.
          <v-btn @click="snackbar = false">Close</v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from 'graphql-tag';
import DeviceImage from '@/components/Device/DeviceImage.vue';
import DeviceImage360 from '@/components/Device/DeviceImage360.vue';
import DeviceLiveView from '@/components/Device/DeviceLiveView.vue';

const LATEST_DEVICE_IMAGE = gql`
  subscription latest_image($device: String!) {
    files(
      where: {
        _and: {
          device_id: {
            _eq: $device
          }
          url: {
            _ilike: "%Z.jpg"
          }
        }
      }
      order_by: {
        created: desc
      }
      limit: 1
    ) {
        id
        device_id
        url
        created
    }
  }
`;

const CHANGE_MODE = gql`
mutation change_mode($id: String!, $mode: String!) {
  update_devices(
    where: {
      id: {
        _eq: $id
      }
    }
    _set: {
      mode: $mode
    }
  ) {
    returning {
      id
      mode
    }
  }
}
`;

export default {
  name: 'DeviceTabStatus',
  data() {
    return {
      userStarted: false,
      default_thumb: {
        url: '/noimage.png',
        created: '20200601',
      },
      thumbnail: null,
      snackbar: false,
      previousMode: null,
    };
  },
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  computed: {
    imageTimestamp() {
      if (this.thumbnail) {
        const months = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];

        const d = new Date(this.thumbnail.created);
        const space = ' ';
        const colon = ':';
        // eslint-disable-next-line
        const minutes = '' + d.getMinutes();
        const date = d.getDate() + space + months[d.getMonth()] + space + d.getFullYear()
        + space + d.getHours() + colon + minutes.padStart(2, '0') + colon + d.getSeconds();
        return date;
      }
      return null;
    },
    thumb() {
      return this.thumbnail || this.default_thumb;
    },
    isVrCamera() {
      const { description } = this.device;
      const vrCameras = [
        'Ricoh Theta V',
        'Theta V',
        'Ricoh Theta Z1',
        'Theta Z1',
        'Labpano Pilot One (EE)',
        'Labpano Pilot Era',
      ];
      return !!(vrCameras.find((el) => el === description));
    },
  },
  components: {
    DeviceImage,
    DeviceImage360,
    DeviceLiveView,
  },
  mounted() {
  },
  methods: {
    toggleLive() {
      this.userStarted = true;
      let mode = '';
      if (this.device.mode === 'LiveView') {
        mode = this.previousMode || 'Idle';
      } else {
        mode = 'LiveView';
      }
      this.previousMode = this.device.mode;

      const variables = {
        id: this.device.id,
        mode,
      };
      this.$apollo.mutate({
        mutation: CHANGE_MODE,
        variables,
        // eslint-disable-next-line
        update: (cache, { data: { update_devices } }) => {
          // Read the data from our cache for this query.
          // eslint-disable-next-line
        },
        error: (err) => {
          console.log(err);
        },
      });
    },
  },
  apollo: {
    $subscribe: {
      thumbnail: {
        // graphql query
        query: LATEST_DEVICE_IMAGE,
        variables() {
          return {
            device: this.device.id,
          };
        },
        result(data) {
          // Let's update the local data
          const { files } = data.data;
          [this.thumbnail] = files;
        },
      },
    },
  },
};
</script>
